export const ACTIVITY_DISPLAY_NAME_ACCESSORIES = 'Accessories';
export const ACTIVITY_DISPLAY_NAME_CREDIT_APPLICATION = 'Credit Application';
export const ACTIVITY_DISPLAY_NAME_DOC_UPLOAD = 'Doc Upload';
export const ACTIVITY_DISPLAY_NAME_INCENTIVES = 'Incentives';
export const ACTIVITY_DISPLAY_NAME_OFFER = 'Offer';
export const ACTIVITY_DISPLAY_NAME_TEST_DRIVE = 'Test Drive';
export const ACTIVITY_DISPLAY_NAME_TRADE_IN = 'Trade-in';
export const ACTIVITY_DISPLAY_NAME_VEHICLE_PROTECTION = 'Vehicle Protection Products';
export const ACTIVITY_DISPLAY_NAME_VEHICLE_RESERVATION = 'Vehicle Reservation';
